import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, CardActions, CardContent, CardMedia, List, ListItem, Typography } from "@mui/material";
import GlobalNotificationModal from "components/GlobalNotificationModal";
import { IGlobalNotification } from "interfaces/Notifications";

interface IGlobalNotificationsListProps {
  globalNotificationsArray: IGlobalNotification[];
  deleteGlobalNotification: (id: string) => void;
}

const GlobalNotificationsList = ({
  globalNotificationsArray,
  deleteGlobalNotification,
}: IGlobalNotificationsListProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [notifiToShow, setNotifiToShow] = useState<IGlobalNotification | null>(null);

  const handlePreviewOpen = (id: string) => {
    const currentPreview = globalNotificationsArray.filter((notification) => notification._id === id);

    if (currentPreview.length === 1) {
      setNotifiToShow(currentPreview[0]);
      setIsModalOpen(true);
    } else {
      return;
    }
  };

  return (
    <>
      <Typography
        sx={{
          fontFamily: "var(--cygreMedium), sans-serif",
          color: "#2E263D",
          fontSize: "16px",
          lineHeight: 1.22,
          textAlign: "center",
          marginBottom: "24px",
        }}
      >
        {t("currentGlobalNotificationsList")}
      </Typography>
      <List
        dense
        sx={{
          display: "flex",
          gap: "24px",
          marginBottom: "24px",
          flexWrap: "nowrap",
          overflowY: "auto",
        }}
      >
        {!globalNotificationsArray.length ? (
          <ListItem>
            <Typography
              sx={{
                fontFamily: "var(--cygreMedium), sans-serif",
                color: "#2E263D",
                fontSize: "14px",
                lineHeight: 1.22,
                width: "100%",
                textAlign: "center",
              }}
            >
              {t("emptyData")}
            </Typography>
          </ListItem>
        ) : (
          globalNotificationsArray.map((notification) => {
            const { _id, title, description, image } = notification;
            return (
              <ListItem key={_id} disablePadding sx={{ width: "280px" }}>
                <Card sx={{ width: "280px", height: "302px" }}>
                  <CardMedia
                    sx={{ height: 140, backgroundSize: "contain" }}
                    image={image as string}
                    title="green iguana"
                  />
                  <CardContent>
                    <Typography
                      sx={{
                        fontFamily: "var(--cygreMedium), sans-serif",
                        color: "#2E263D",
                        fontSize: "20px",
                        lineHeight: 1.22,
                        marginBottom: "8px",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      component="h3"
                    >
                      {title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "var(--cygreMedium), sans-serif",
                        color: "#2E263D",
                        fontSize: "14px",
                        lineHeight: 1.22,
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" onClick={() => handlePreviewOpen(_id)}>
                      {t("previewAndCustomisation")}
                    </Button>
                    <Button size="small" onClick={() => deleteGlobalNotification(_id)}>
                      {t("delete")}
                    </Button>
                  </CardActions>
                </Card>
              </ListItem>
            );
          })
        )}
      </List>
      {isModalOpen && notifiToShow && (
        <GlobalNotificationModal open={isModalOpen} setIsModalOpen={setIsModalOpen} notificationData={notifiToShow} />
      )}
    </>
  );
};

export default GlobalNotificationsList;
